import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_REPORT_BUG } from 'api/actionTypes';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import postWithState from 'client/actions/postWithState';

import useDispatch from 'client/hooks/useDispatch';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';

const formFields = [
  {
    id: 'message',
    type: 'long_text',
    title: 'Describe the bug here:',
    properties: {
      placeholder: 'Write here...',
    },
  },
];

const SrReportBugForm = (props) => {
  const { userId, listingId, section, onSubmit, onClose } = props;

  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(false);

  const _onSubmit = useCallback(
    (_formValues) => {
      setIsBusy(true);
      dispatch(postWithState, {
        action: SR_API_ACTION_REPORT_BUG,
        payload: {
          userId,
          listingId,
          section,
          ..._formValues,
        },
      })
        .then((bugReport) => {
          return onSubmit(bugReport);
        })
        .then(() => {
          setIsBusy(false);
        })
        .catch(() => {
          setIsBusy(false);
        });
    },
    [userId, listingId, section, onSubmit, dispatch, setIsBusy],
  );

  return (
    <Formik
      enableReinitialize
      validate={createFormValidationFn(formFields)}
      initialValues={createInitialValues({
        formFields: formFields,
        defaultValues: {},
      })}
      onSubmit={_onSubmit}
      render={(formikBag) => {
        return (
          <SrBox bgColor="white" borderRadius="24px" padding="28px 25px 30px">
            <Form className="SrReportBugForm">
              <SrText font="greycliff" weight="800" size="28" lineHeight="34px">
                🐞 Log Product Bug
              </SrText>
              {formFields.map((formField) => (
                <SrFormikField
                  key={formField.id}
                  formField={formField}
                  formikBag={formikBag}
                  theme={SR_FIELD_THEME_ADOBE}
                />
              ))}
              <SrFlex marginTop="20px" gap="33px" justify="between">
                {onClose && (
                  <SrBox width="100%">
                    <SrButton onClick={onClose} theme={SR_BUTTON_THEME_ADOBE_GREY}>
                      Cancel
                    </SrButton>
                  </SrBox>
                )}
                <SrBox width="100%">
                  <SrButton
                    type="submit"
                    disabled={!formikBag.isValid || isBusy}
                    theme={SR_BUTTON_THEME_ADOBE_BLUE}
                  >
                    Submit
                  </SrButton>
                </SrBox>
              </SrFlex>
            </Form>
          </SrBox>
        );
      }}
    />
  );
};

SrReportBugForm.propTypes = {
  userId: PropTypes.number,
  listingId: PropTypes.number,
  section: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

SrReportBugForm.displayName = 'SrReportBugForm';

export default SrReportBugForm;
